// ModalBoletoControl.js

import React, { useState, useCallback } from 'react';
import api from '../../src/config/axiosConfig';
// Certifique-se de que o caminho para o axiosConfig está correto
import './ModalBoletoControl.css';

const ModalBoletoControl = ({ isOpen, onClose, codVenda: initialCodVenda }) => {
    const [file, setFile] = useState(null);
    const [codVenda, setCodVenda] = useState(initialCodVenda);
    const [boletos, setBoletos] = useState([]);
    const [selectedBoleto, setSelectedBoleto] = useState("");

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file || !codVenda) {
            alert("Por favor, selecione um arquivo e insira o código de venda.");
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await api.post(`/boletos/upload/${codVenda}`, formData);
            if (response.status === 200) {
                alert("Arquivo enviado com sucesso.");
            } else {
                alert("Falha no envio do arquivo.");
            }
        } catch (error) {
            console.error("Erro ao enviar o arquivo", error);
            alert("Erro ao enviar o arquivo.");
        }
    };

    const listarBoletos = useCallback(async () => {
        if (!codVenda) {
            alert("Por favor, insira o código de venda.");
            return;
        }

        try {
            const response = await api.get(`/boletos/listar/${codVenda}`);
            if (response.status === 200) {
                const boletosList = response.data;
                if (boletosList.length > 0) {
                    setBoletos(boletosList);
                    setSelectedBoleto(boletosList[0]);
                } else {
                    alert("Nenhum boleto encontrado para o código de venda.");
                    setBoletos([]);
                }
            } else {
                alert("Falha ao buscar boletos.");
            }
        } catch (error) {
            console.error("Erro ao listar boletos", error);
            alert("Erro ao listar boletos.");
        }
    }, [codVenda]);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            listarBoletos();
        }
    };

    const handleDownload = async () => {
        if (!selectedBoleto) {
            alert("Por favor, selecione um boleto para download.");
            return;
        }

        try {
            const response = await api.get(`/boletos/download/${codVenda}/${selectedBoleto}`, {
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', selectedBoleto);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Erro ao baixar o boleto", error);
            alert("Erro ao baixar o boleto.");
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-boleto">
            <div className="modal-boleto-content">
                <span className="close" onClick={onClose}>&times;</span>

                <h3>Gerenciar Boletos</h3>

                <label htmlFor="codVenda">Digite o Código da Venda e Clique [Enter]:</label>
                <input
                    id="codVenda"
                    type="text"
                    value={codVenda}
                    onChange={(e) => setCodVenda(e.target.value)}
                    onKeyPress={handleKeyPress}
                    style={{ marginBottom: '10px', marginLeft: '20px', height: '30px', padding: '5px', width: '100px' }}
                />

                <div className="upload-section">
                    <input type="file" onChange={handleFileChange} />
                    <div className="button-container">
                        <button className="upload" onClick={handleUpload}>Upload</button>
                    </div>
                </div>

                {boletos.length > 0 && (
                    <div className="download-section">
                        <label htmlFor="boletos-select">Selecione o boleto para download:</label>
                        <select
                            id="boletos-select"
                            value={selectedBoleto}
                            onChange={(e) => setSelectedBoleto(e.target.value)}
                            style={{ marginBottom: '10px', padding: '5px', width: '100%' }}
                        >
                            {boletos.map((boleto) => (
                                <option key={boleto} value={boleto}>
                                    {boleto}
                                </option>
                            ))}
                        </select>
                        <div className="button-container">
                            <button className="download" onClick={handleDownload}>Download</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ModalBoletoControl;